import type { RpcOptions } from '../types/rpc'

export default ({
  key = 'useCountryRedirect',
  params,
  options,
}: {
  key?: string
  params?: any
  options?: RpcOptions
}) => {
  const currentShop = useCurrentShop()
  const availableShops = useAvailableShops()

  const {
    refresh,
    data: userCountry,
    status,
  } = useRpc('resolveIpToCountry', key, params, options)

  // The SSR HTML/payload is shared between users by the route-level cache
  // (see `utils/ssrCache/index.ts`), and its cache key does not include the
  // requesting IP. Resolving the country during SSR would therefore bake one
  // user's geo detection into the payload that every subsequent visitor of
  // the same path receives for up to 10 minutes. Always defer to the client.
  const safeRefresh: typeof refresh = async (...args) => {
    if (import.meta.server)
      return undefined as unknown as ReturnType<typeof refresh>
    return refresh(...args)
  }

  const userShop = computed(() => {
    return availableShops.value.find((i) => i.country === userCountry.value)
  })

  const userCountryShopAvailable = computed(
    () =>
      userCountry.value !== false &&
      userCountry.value !== currentShop.value.country &&
      userShop.value !== undefined,
  )

  return {
    refresh: safeRefresh,
    status,
    userCountry,
    userShop,
    userCountryShopAvailable,
  }
}
